import { useEffect, useState } from 'react'
import { Alert, Button, Checkbox, Group, Stack, Text } from '@mantine/core'

import { DataCard } from '@/components/ui'
import { useGravarRestricoes, useRestricoesDoRobo } from '@/api/robo'

/**
 * "O que o <nome> nunca faz" (spec 2026-09-30-robo-agente-pessoal §4.1). O robô
 * propõe ação por cartão, como o @Atendente; aqui o dono tira dele as que não quer
 * ver propostas. Só restringe: o que o dono pode fazer sozinho não muda.
 */
export function RestricoesDoRobo({ nome }: { nome: string }) {
  const { data, isError } = useRestricoesDoRobo()
  const gravar = useGravarRestricoes()
  const [marcados, setMarcados] = useState<string[]>([])
  const [salvo, setSalvo] = useState(false)

  // Sincroniza pelo VALOR da lista gravada, não pela identidade de `data`: um
  // objeto novo com o mesmo conteúdo (refetch, mock) não pode reescrever o estado.
  const gravados = (data?.itens ?? []).map((i) => i.alvo).join('\n')
  useEffect(() => { setMarcados(gravados ? gravados.split('\n') : []) }, [gravados])

  const salvar = async () => {
    await gravar.mutateAsync({ itens: marcados.map((alvo) => ({ alvo, tenant_id: null })) })
    setSalvo(true)
  }

  return (
    <DataCard title={`O que o ${nome} nunca faz`}>
      <Stack gap="sm">
        <Text size="sm" c="dimmed">
          Ele nunca propõe estas ações, nem quando você pede. Não tira nada de você: só do robô.
        </Text>
        {isError && <Alert color="red" variant="light">Não consegui ler a lista agora.</Alert>}
        <Checkbox.Group value={marcados} onChange={(v) => { setMarcados(v); setSalvo(false) }}>
          <Stack gap="xs">
            {(data?.opcoes ?? []).map((o) => (
              <Checkbox key={o.alvo} value={o.alvo} label={o.rotulo} />
            ))}
          </Stack>
        </Checkbox.Group>
        <Group>
          <Button loading={gravar.isPending} onClick={salvar}>Salvar</Button>
          {salvo && <Text size="sm" c="dimmed">Salvo.</Text>}
        </Group>
      </Stack>
    </DataCard>
  )
}
